import './DocViewerDialog.css';
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function DocViewerDialog(props) {

    const { translate, open, docs = [], fileName, handleClose } = props;

    return (
        <Dialog
            fullWidth
            maxWidth="xl"
            open={open}
            onClose={handleClose}
            className='dialog'
        >
            <Box className="file-name">{fileName}</Box>
            <Box className="close-btn">
                <IconButton color="primary" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <DocViewer 
                documents={docs}
                config={{
                    header: {
                      disableHeader: true,
                    },
                }}
                pluginRenderers={DocViewerRenderers}
                language={localStorage.getItem('_locale') | 'en'}
                style={{ height: "100vh" }}
            />
        </Dialog>
    );
}

export default withTranslate(DocViewerDialog);